import { Switch } from './switch-component';
export default Switch;
